import { Box, Slider } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
import { getEvdaFranceDateFilterState } from "../../../redux/selectors/filterSelector";
import { FilterAction } from "../../../redux/states/filterState";

export type Props = {
  SliderMin: number;
  SliderMax: number;
}

const DateIntervalFilterComponent:React.FC<Props>=({SliderMin,SliderMax})=>{
  const dispatch = useDispatch()
  const dateFilter = useSelector(getEvdaFranceDateFilterState)
  const [intervalToDisplay, setIntervalToDisplay] = useState<string>("")
  const { t } = useTranslation();
  const minDistance=5;

  const ariaLabel = (activeThumb: number): string => {
    if (activeThumb === 0) {
      return "Début de la période d'observation";
    } else {
      return "Fin de la période d'observation";
    }
  }; 

  useEffect(()=>{
    setIntervalToDisplay(
      dateFilter.selectedIntervalDate[0]
      + " - "
      + dateFilter.selectedIntervalDate[1]
    );
  }, [dateFilter]);

  const handleChange = (
    event: Event,
    newValue: number | number[],
    activeThumb: number,
  ) => {
    if (!Array.isArray(newValue)) {
      return;
    }

    if (activeThumb === 0) {
      dispatch(FilterAction.setEvdaFranceDate(([Math.min(newValue[0], dateFilter.selectedIntervalDate[1] - minDistance), dateFilter.selectedIntervalDate[1]])));
    } else {
      dispatch(FilterAction.setEvdaFranceDate([dateFilter.selectedIntervalDate[0], Math.max(newValue[1], dateFilter.selectedIntervalDate[0] + minDistance)]));
    }
  };

  return(
    <div className="filter-type-container">
      <label>{t("filter_label_interval_date")}</label>
      <div className="interval-container">
        <div className="interval">
          <span>{intervalToDisplay}</span>
        </div>
        <Box 
          sx={{ 
            width: 252,
            '& .MuiSlider-thumb': {
              borderRadius: '50px',
              borderWidth:'50px',
              width:'17px',
              height:'17px',
              border:'2px solid #286AC7',
              color:"#ffffff"
            }
          }}
        >
          <Slider
            min={SliderMin}
            max={SliderMax}
            value={dateFilter.selectedIntervalDate}
            onChange={handleChange}
            getAriaLabel={ariaLabel}
          />
        </Box>
      </div>
    </div>
  )
}

export default DateIntervalFilterComponent;